import { Component, OnInit, ViewChild, enableProdMode } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { DxDataGridComponent, DxScrollViewComponent, DxDataGridModule, DxSelectBoxModule, DxCheckBoxModule, DxTemplateModule } from 'devextreme-angular';
import { TraspasoService } from '../../../services/formulacion/traspaso.service';
import { GeneralService } from '../../../services/formulacion/general.service';
import { environment } from '../../../../environments/environment';
import { UtilHelper } from '../../../_helpers/util';
declare var jQuery: any;
declare var toastr;

@Component({
  selector: 'app-rpt-seg-traspaso',
  templateUrl: './rpt-seg-traspaso.component.html',
  styleUrls: [],
  providers: [TraspasoService, GeneralService]
})
export class RptSegTraspasoComponent implements OnInit {
  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;
  @ViewChild(DxScrollViewComponent) scrollView: DxScrollViewComponent;
  scrollByContent = true;
  scrollByThumb = true;
  dataCP: any = [];
  gestiones: any = [];
  gestion: number = 3;
  baseUrl = environment.apiEndpoint;

  constructor(private _ts: TraspasoService, public _gs: GeneralService) {
    this.getTraspasosSeguimiento();
  }

  ngOnInit() {
  }

  onToolbarPreparing(e) {
    e.toolbarOptions.items.unshift({
      location: 'before',
      widget: 'dxButton',
      options: {
        icon: 'refresh',
        text: 'Actualizar',
        onClick: this.refreshDataGrid.bind(this)
      }
    });
  }

  refreshDataGrid(e) {
    this.getTraspasosSeguimiento();
    this.dataGrid.instance.refresh();
  }

  getTraspasosSeguimiento() {
    this._ts.getTraspasosSeguimiento().subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.dataCP = result.data;
        } else {
          this.dataCP = [];
        }
      });
  }

  postAvanceFus(id: number) {
    this._gs.postRptAvanceFus({ id: id }).subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          //this.popupVisibleAdd = false;
        }
      });
  }
}
